export enum ExtensionType {
  PDF = 'pdf',
  ZIP = 'zip',
}
